export default "__VITE_ASSET__5e360dbb__"